import { FC, SVGProps, useEffect, useRef, useState } from 'react'
import { ReactComponent as BookingIcon } from 'src/assets/svg/booking-brand.svg'
import { ReactComponent as ExpediaIcon } from 'src/assets/svg/expedia-brand.svg'
import { ReactComponent as CloseIcon } from 'src/assets/svg/close.svg'
import { ReactComponent as FacebookIcon } from 'src/assets/svg/facebook.svg'
import { ReactComponent as GlobeIcon } from 'src/assets/svg/Globe.svg'
import { ReactComponent as GoogleIcon } from 'src/assets/svg/google.svg'
import { ReactComponent as InstagramIcon } from 'src/assets/svg/instagram.svg'
import { ReactComponent as LinkedInIcon } from 'src/assets/svg/linkedin.svg'
import { ReactComponent as NewsAndBlogsIcon } from 'src/assets/svg/New-and-Blogs.svg'
import { ReactComponent as RedditIcon } from 'src/assets/svg/reddit.svg'
import { ReactComponent as TikTokIcon } from 'src/assets/svg/tiktok.svg'
import { ReactComponent as TripadvisorIcon } from 'src/assets/svg/tripadvisor.svg'
import { ReactComponent as ThreadsIcon } from 'src/assets/svg/threads-square-svg.svg'
import { ReactComponent as XIcon } from 'src/assets/svg/x.svg'
import { ReactComponent as YouTubeIcon } from 'src/assets/svg/youtube.svg'
import styles from './sourcesModal.module.scss'

const SOURCE_ICON_MAP: Record<string, FC<SVGProps<SVGSVGElement>>> = {
  booking: BookingIcon,
  expedia: ExpediaIcon,
  facebook: FacebookIcon,
  'google reviews': GoogleIcon,
  instagram: InstagramIcon,
  linkedin: LinkedInIcon,
  'news & blogs': NewsAndBlogsIcon,
  reddit: RedditIcon,
  threads: ThreadsIcon,
  tiktok: TikTokIcon,
  tripadvisor: TripadvisorIcon,
  twitter: XIcon,
  youtube: YouTubeIcon,
}

interface SourcesModalProps {
  cardRef: React.RefObject<HTMLDivElement>
  onClose: () => void
  sources: string[]
}

export const SourcesModal: FC<SourcesModalProps> = ({
  cardRef,
  onClose,
  sources,
}) => {
  const [position, setPosition] = useState({ left: 0, top: 0 })
  const modalRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const updatePosition = () => {
      if (cardRef.current) {
        const cardRect = cardRef.current.getBoundingClientRect()

        setPosition({
          left: cardRect.left + 60,
          top: cardRect.bottom - 100,
        })
      }
    }

    updatePosition()

    window.addEventListener('resize', updatePosition)
    return () => window.removeEventListener('resize', updatePosition)
  }, [cardRef])

  const capitalize = (str: string) =>
    str.replace(/\b\w/g, (c) => c.toUpperCase())

  const getIcon = (source: string) => {
    return SOURCE_ICON_MAP[source.toLowerCase()] || GlobeIcon
  }

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div
        className={styles.modal}
        onClick={(e) => e.stopPropagation()}
        ref={modalRef}
        style={{ left: `${position.left}px`, top: `${position.top}px` }}
      >
        <div className={styles.header}>
          <h3 className={styles.title}>All Sources</h3>
          <button className={styles.closeButton} onClick={onClose}>
            <CloseIcon className={styles.closeIcon} />
          </button>
        </div>
        <div className={styles.content}>
          <div className={styles.grid}>
            {sources.map((source) => {
              const Icon = getIcon(source)
              return (
                <div className={styles.sourceItem} key={source}>
                  <Icon
                    className={
                      ['booking', 'expedia'].includes(source.toLowerCase())
                        ? `${styles.sourceIcon} ${styles.monoBrandIcon}`
                        : styles.sourceIcon
                    }
                  />
                  <span className={styles.sourceName}>
                    {capitalize(source)}
                  </span>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
